import { render, staticRenderFns } from "./InputActivity.vue?vue&type=template&id=1c5121b4&scoped=true&"
import script from "./InputActivity.vue?vue&type=script&lang=js&"
export * from "./InputActivity.vue?vue&type=script&lang=js&"
import style0 from "./InputActivity.vue?vue&type=style&index=0&id=1c5121b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5121b4",
  null
  
)

export default component.exports